export { default } from './DashboardPage'



// WEBPACK FOOTER //
// ./src/App/DashboardPage/index.js